import React, { useCallback, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Cell } from 'styled-css-grid';

import { FormField, xcriticalFormPropertyChange } from '@xcritical/forms';

import { Label } from '@crm-framework/label';

import {
  dictionariesActions,
  DictionarySelect,
  IDictionarySelect,
  useDictionary,
} from '@crm-package/dictionaries';

import {
  COUNTRY,
  LeadDetailsDictionaries,
  LEAD_FORM_NAME,
  STATE,
  IsHorizontalContext,
} from '../consts';
import { getCountryStateOptions } from '../selectors';
import { CountryWrapper } from '../styled';

export const CountryStateBlock: React.FC<{
  selectProps?: Partial<IDictionarySelect>;
}> = ({ selectProps }) => {
  const dispatch = useDispatch();
  const countryStates = useDictionary(LeadDetailsDictionaries.countryStates);
  const stateOptions = useSelector(getCountryStateOptions);
  const isHorizontal = useContext(IsHorizontalContext);

  const onHandleChangeCountry = useCallback(
    (v: number) => {
      if (!countryStates.some((item) => item.countryId === v)) {
        dispatch(xcriticalFormPropertyChange(LEAD_FORM_NAME, STATE, undefined));
      } else {
        dispatch(
          dictionariesActions.addOrUpdate({
            [LeadDetailsDictionaries.currentStateDictionary]:
              countryStates.find((item) => item.countryId === v).states,
          })
        );
      }
    },
    [countryStates]
  );

  const countryFormField = (
    <FormField
      inputId={COUNTRY}
      name={COUNTRY}
      component={DictionarySelect}
      dictionaryName={LeadDetailsDictionaries.country}
      shouldFitContainer
      openMenuOnFocus
      menuPlacement="auto"
      hideSelectedOptions={false}
      isSearchable
      menuPosition="fixed"
      appearance="compact"
      menuShouldBlockScroll
      onChange={onHandleChangeCountry}
      {...selectProps}
    />
  );

  const stateFormField = (
    <FormField
      inputId={STATE}
      name={STATE}
      component={DictionarySelect}
      dictionaryName={LeadDetailsDictionaries.currentStateDictionary}
      shouldFitContainer
      openMenuOnFocus
      menuPlacement="auto"
      hideSelectedOptions={false}
      isSearchable
      menuPosition="fixed"
      appearance="compact"
      menuShouldBlockScroll
      {...selectProps}
    />
  );

  return (
    <>
      <Cell>
        <Label isRequired htmlFor={COUNTRY}>
          Country
        </Label>
      </Cell>
      {isHorizontal ? (
        <CountryWrapper withState={stateOptions != null}>
          {countryFormField}
          {stateOptions != null && stateFormField}
        </CountryWrapper>
      ) : (
        <>
          {countryFormField}
          {stateOptions != null && (
            <>
              <Cell>
                <Label htmlFor={STATE}>State</Label>
              </Cell>
              {stateFormField}
            </>
          )}
        </>
      )}
    </>
  );
};
